"use strict";
// _partialFile.js
new Vivus("textAnimation", {
  // svgに指定するid名
  duration: 250, // アニメーションの長さ
  forceRender: false, //パスが更新で再レンダリングさせない
  start: "autostart", // ページロード時に自動的にアニメーション開始
});
